<template>
    <v-container fluid  ma-0 pb-0>
        <!--Details View-->
        <v-expansion-panels>
            <v-expansion-panel v-if="$vuetify.breakpoint.smAndDown">
                <v-expansion-panel-header >Client Information</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <userInfoDisplay
                            :setName="`${client.name} ${client.family_name}`"
                            :setEmail="client.guardian_email"
                            :setPhone="client.guardian_phone_number"
                            :setType="!!!client.typeName ? 'Unassigned' : client.typeName"
                            :setStatus="client.active"
                            setUserType="Employees"
                            :setGuardianName="client.guardian_name"
                            :setUserNumber="client.employees == undefined ? 0 : Object.keys(client.employees).length"
                            setCompany="Unnasigned"
                            :setDOB="client.birthdate"
                            :setCreatedDate="client.systemCreatedDateTime"
                            :setAddress="client.address"
                    >
                    </userInfoDisplay>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <userInfoDisplay v-if="$vuetify.breakpoint.mdAndUp"
                         :setName="`${client.name} ${client.family_name}`"
                         :setEmail="client.guardian_email"
                         :setPhone="client.guardian_phone_number"
                         :setType="!!!client.typeName ? 'Unassigned' : client.typeName"
                         :setStatus="client.active"
                         setUserType="Employees"
                         :setGuardianName="client.guardian_name"
                         :setUserNumber="client.employees == undefined ? 0 : Object.keys(client.employees).length"
                         setCompany="Unnasigned"
                         :setDOB="moment(client.birthdate).format(DATE_FORMAT.LOCALE)"
                         :setCreatedDate="moment(client.systemCreatedDateTime).format(DATE_FORMAT.LOCALE)"
                         :setAddress="client.address"
        >
        </userInfoDisplay>
    </v-container>
</template>

<script>
    import {ALERT_TYPES, WRONG_ID_SUPPLIED} from "@/shared/enums/AlertTexts";
    import {TOKEN} from "@/shared/enums/TokenSeparator";
    import moment from "moment";
    import {DATE_FORMAT} from "@/shared/enums/DateFormats";
    import headerChartBar from '@/components/orgApps/charts/headerChartBars';
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const userInfoDisplay = ()=> import( '@/components/common/UserInfoDisplay');

    export default {
        name: "ClientVerticalHeader",
        props:['hId'],
        components: {
            responsiveButton,
            headerChartBar,
            userInfoDisplay
        },
        data(){
            return {
                client:{},
                activeBtn: 0,
            }
        },
        computed:{
            moment(){
                return moment;
            },
            DATE_FORMAT(){
                return DATE_FORMAT;
            },
        },
        methods:{
            async initialize(){
                if(this.hId)
                {
                    await this.$store.dispatch('getClient',{id: this.hId});
                    this.client = this.$store.getters.getClient;

                    if(!this.client.hasOwnProperty('id'))
                    {
                        this.alertType = ALERT_TYPES.ERROR;
                        this.alertText = WRONG_ID_SUPPLIED;
                        this.okCall = () => this.close();
                        this.openAlert = true;
                        return;
                    }

                    this.client.guardian_phone_number = this.client.guardian_phone_number.replace(/\+1/,'');
                }
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style scoped>

</style>